import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { queryKeys } from './queryKeys';
import type { Tables } from '@/integrations/supabase/types';

export type RecurringTransaction = Tables<'recurring_transactions'>;

/**
 * Fetch recurring transactions
 * Used by: Recurring page
 */
export function useRecurringTransactions(activeOnly = false) {
  return useQuery({
    queryKey: activeOnly ? queryKeys.recurring.active() : queryKeys.recurring.list(),
    queryFn: async () => {
      let query = supabase
        .from('recurring_transactions')
        .select('*')
        .order('next_occurrence', { ascending: true });

      if (activeOnly) {
        query = query.eq('is_active', true);
      }

      const { data, error } = await query;
      if (error) throw error;
      return (data || []) as RecurringTransaction[];
    },
  });
}
